module.exports = __webpack_public_path__ + "static/media/suneco-logo.7096b286.png";